import { GeoZonesTabState, WorkLayer } from "./types";
import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from "@reduxjs/toolkit";

const initialState: GeoZonesTabState = {
  works: {
    current: [],
    layers: [],
    enabled: false
  },
  toggles: {
    cadastre: 'Заливка'
  },
}

const geoZonesTabSlice = createSlice({
  name: 'geozone_tab_slice',
  initialState,
  reducers: {
    addOperationLayer(state: GeoZonesTabState, action: PayloadAction<WorkLayer>) {
      state.works.layers.push(action.payload)
    },
    clearOperationLayers(state: GeoZonesTabState, action: PayloadAction) {
      state.works.layers = []
    },
    resetGeoZoneTabState(state: GeoZonesTabState, action: PayloadAction) {
      return initialState
    },
    setGeoZonesTabToggleState(state: GeoZonesTabState, action: PayloadAction<{ id: string, enabled: boolean | string }>){
      state.toggles[action.payload.id] = action.payload.enabled
    },
    setGeoZonesTabWorksLayerEnabled(state: GeoZonesTabState, action: PayloadAction<{ enabled: boolean }>){
      state.works.enabled = action.payload.enabled
    },
    setGeoZonesTabWork(state: GeoZonesTabState, action: PayloadAction<{ id : string }>){
      const current = state.works.current.indexOf(action.payload.id)
      current !== -1 ? state.works.current.splice(current, 1) : state.works.current.push(action.payload.id)
    },
    setGeoZonesTabWorks(state: GeoZonesTabState, action: PayloadAction<{ ids : string[] }>){
      state.works.current = action.payload.ids
    }
  }
})

export const actions = geoZonesTabSlice.actions
export default geoZonesTabSlice.reducer